module.exports = "/assets/30f3c5d2a8d476fd5a41510111284591.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JK.png
// module id = 2637
// module chunks = 0